module.exports = "/_next/static/images/086909f1dbfa5443ab3d2920d56d1f4b-mulher-perfil-segurando-cartao-xs@3x.jpg.webp";